import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "../shared/useIsAdmin";

/**
 * Route guard for admin-only pages.
 *
 * While the admin check is in-flight, renders a loading state.
 * Non-admins (403 from /admin/access) are redirected to /dashboard.
 * The API layer (require_admin dependency) is the authoritative guard;
 * this component is a UX shortcut so non-admins never see a blank page.
 */
export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-bg p-6 font-sans">
        <p className="text-text-muted text-body">Loading…</p>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
